import { jsx as _jsx } from "react/jsx-runtime";
import { classNames, responsiveClassNames } from "../../utilities/props.js";
import s from "./Loader.module.css";
const Loader = (props) => {
    const { size = "small", color = "primary", className, attributes } = props;
    const ariaLabel = props.ariaLabel || attributes?.["aria-label"];
    const rootClassNames = classNames(s.root, className, responsiveClassNames(s, "--size", size), color && s[`--color-${color}`]);
    return (_jsx("span", { ...attributes, role: "progressbar", "aria-live": ariaLabel ? "assertive" : undefined, "aria-label": ariaLabel, className: rootClassNames, children: _jsx("span", { className: s.inner }) }));
};
Loader.displayName = "Loader";
export default Loader;
